<template>
    <BaseFrame
      cancelText="取消"
      clearText=""
      submitText="保存"
      @submit="toSubmit">
      <div class="container" slot="content">
        <lk-card title='用药提醒信息' class='remindInfo'>
          <div class='remindInfoInner'>
            <lk-form ref="remindInfo" :label-width="100" :model='info' :rules='rules' >
              <lk-form-item label='门店名称:' class="ivu-form-item-required">
                <storeListSelect v-model="info.storeId" @on-change="handleChangeStore" :multiple="true" :disabled="!canEdit" style="width:300px"></storeListSelect>
              </lk-form-item>
              <lk-form-item label="规则名称:" prop="role">
                <lk-input :maxlength='40' placeholder='请输入' v-model.trim="info.roleName" style="width:300px" clearable></lk-input>
              </lk-form-item>
              <lk-form-item label="用药提醒商品:" prop="drug" class="ivu-form-item-required">
                <div>
                  <InputSearch
                    style="width: 300px;display:inline-block;"
                    placeHolder="商品编码、通用名、商品名"
                    :inputDisabled="!canEdit || !info.storeId"
                    v-model.trim="info.goodsInput"
                    @selected='selected'
                    @getData='getGoodsList'
                    :data='goodsData'
                    :columns='goodsColumns'
                    :reset="true">
                  </InputSearch>
                  <div style="width: 70%;display:flex;flex-wrap:wrap;background-color:rgba(243,250,254);margin-top:16px;padding-bottom:10px;font-weight:500;line-height: 18px;">
                    <div v-for="(fieldItem, index) in showFields" style="width:33%;display:flex;margin-top: 10px;" :key="index">
                      <div style="width:30%;text-align:right;">{{fieldItem.title}}</div>
                        <div>
                          {{!selectedItem[fieldItem.key]? '' : selectedItem[fieldItem.key]}}
                        </div>
                    </div>
                  </div>
                </div>
              </lk-form-item>
              <lk-form-item label="用药提醒间隔:" prop="intervalTimes">
                <span>该药品销售订单创建后第</span>
                <lk-input-number
                  :max="999"
                  :min="1"
                  placeholder='请输入'
                  v-model="info.intervalTimes"
                  style="width:70px;margin: 0 5px;">
                </lk-input-number>
                <span>天上午8时，系统将自动提醒患者绑定药师发送用药提醒</span>
              </lk-form-item>
              <lk-form-item label='' prop='prescriptionFirst'>
                <lk-checkbox v-model="info.prescriptionFirst"> 优先按处方中填写的用药提醒天数</lk-checkbox>
                <div class="tips">
                  <span>勾选后，优先按订单处方中的“用药提醒天数”分别发送提醒，如处方中未填写该字段，再根据此规则中用药提醒间隔发送提醒。</span>
                </div>
              </lk-form-item>
              <lk-form-item label="提醒内容:" prop="remark">
                <lk-input placeholder='请输入' type='textarea' :maxlength='200' v-model="info.remark" :rows="4" style="width: 60%;margin: 10px 0;"></lk-input>
                <div class="tips">
                  <span>如需在提醒内容中插入随提醒时间变化的日期，可输入： #{参数1,参数2} 系统可将此部分内容识别成日期。</span>
                  <span>— 参数1用于确定格式，可填“年月日”或“月日”，如填“年月日”，将展示为 XXXX年XX月XX日，如填“月日”，将展示为 XX月XX日。</span>
                  <span>— 参数2用于确定日期，可填写 -99~99 的数字；以提醒日期为基准，-1表示提醒时间前一天，+1表示提醒时间后一天，以此类推。</span>
                  <span>举例：在2023年3月30日的用药提醒中，#{月日,-3} 会被自动识别为“3月27日”，#{年月日,0} 会被自动识别为“2023年3月30日”。</span>
                </div>
              </lk-form-item>
              <lk-form-item label='可选配置:' prop='rebuyCancel'>
                <lk-checkbox v-model="info.rebuyCancel"> 如患者提前复购，取消前一单的复购提醒</lk-checkbox>
                <div class="tips">
                  <span>勾选后，如患者在该药品前一单未到用药提醒日期时提前复购，则前一单不会提醒患者绑定药师发送用药提醒。</span>
                </div>
              </lk-form-item>
            </lk-form>
          </div>
        </lk-card>
      </div>
    </BaseFrame>
</template>

<script>
import BaseFrame from '@/components/frame/BaseFrame.vue';
import InputSearch from '@/components/InputSearch.vue';
import remind from '@/services/drugUseRemind';
import utils from '@/libs/utils';

export default {
  name: 'drugUseRemindEdit',
  components: {
    BaseFrame,
    InputSearch,
  },
  data() {
    const validateIntervalTimes = (rule, value, callback) => {
      if (value === '' || value <= 0) {
        callback(new Error('请设置间隔时间'));
      } else {
        callback();
      }
    };
    return {
      selectedItem: {},
      info: {
        storeId: '',
        roleName: '',
        goodsInput: '',
        intervalTimes: 0,
        remark: '',
        prescriptionFirst: true,
        rebuyCancel: false,
      },
      goodsData: [],
      goodsColumns: [
        { title: '商品编码', key: 'drugSerialCode', width: '65px' },
        { title: '药品通用名', key: 'approvedDrugNames', width: '142px' },
        { title: '商品名', key: 'goodsName', width: '90px' },
        { title: '生产厂家', key: 'manufacturer', width: '65px' },
        { title: '规格', key: 'specifications', width: '142px' },
        { title: '包装单位', key: 'drugMiniPackageUnitString', width: '90px' },
      ],
      showFields: [
        {
          title: '商品编码：',
          key: 'drugSerialCode',
        },
        {
          title: '通用名：',
          key: 'approvedDrugNames',
        },
        {
          title: '商品名：',
          key: 'goodsName',
        },
        {
          title: '规格：',
          key: 'specifications',
        },
        {
          title: '包装单位：',
          key: 'drugMiniPackageUnitString',
        },
        {
          title: '生产厂家：',
          key: 'manufacturer',
        },
      ],
      rules: {
        intervalTimes: [
          { validator: validateIntervalTimes },
        ],
        remark: [
          { required: true, message: '请输入提醒内容', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    canEdit() {
      return !this.$route.params.id;
    },
  },
  methods: {
    getInfo() {
      remind.getRemindInfo({ id: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          Object.assign(this.info, {
            storeId: data.storeId,
            roleName: data.roleName,
            remark: data.remark,
            intervalTimes: data.intervalTimes,
            prescriptionFirst: !!(data.prescriptionFirst && data.prescriptionFirst == 1),
            rebuyCancel: !!(data.rebuyCancel && data.rebuyCancel == 1),
          });
          this.selectedItem = {
            id: data.goodsBaseId,
            goodsStoreId: data.goodsStoreId,
            drugSerialCode: data.serialCode,
            approvedDrugNames: data.approvedName,
            specifications: data.spec,
            goodsName: data.goodsName,
            manufacturer: data.manufacturer,
            drugMiniPackageUnitString: data.unit,
          };
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    toSubmit() {
      if (!this.info.storeId) {
        this.$Message.warning('请选择门店');
        return;
      }
      if (!this.selectedItem || Object.keys(this.selectedItem).length == 0) {
        this.$Message.warning('请选择用药提醒商品');
        return;
      }
      this.$refs.remindInfo.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    submit() {
      const params = {
        storeId: this.info.storeId,
        intervalTimes: this.info.intervalTimes,
        remark: this.info.remark,
        roleName: this.info.roleName,
        goodsStoreId: this.selectedItem.goodsStoreId,
        goodsBaseId: this.selectedItem.id,
        prescriptionFirst: this.info.prescriptionFirst ? 1 : 2,
        rebuyCancel: this.info.rebuyCancel ? 1 : 2,
      };
      if (this.$route.params.id) {
        params.id = this.$route.params.id;
        remind.updateRemind(params).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('修改成功');
            this.$router.go(-1);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else {
        remind.newRemind(params).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('提交成功');
            this.$router.go(-1);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    },
    handleChangeStore() {
      this.info.goodsInput = '';
      this.selectedItem = {};
      this.goodsData = [];
    },
    getGoodsList() {
      const params = {
        nameMix: this.info.goodsInput,
        storeId: this.info.storeId,
        status: 1,
        page: 1,
        size: 20,
      };
      remind.getGoodsList(params).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data.list;
          const list = [];
          data.forEach((item) => {
            item.goodsBaseVO.goodsBase.goodsStoreId = item.goodsStore.id;
            list.push(item.goodsBaseVO.goodsBase);
          });
          this.goodsData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    selected(val) {
      this.selectedItem = val;
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getInfo();
    } else if (this.$store.state.storeInfo.id && this.$store.state.storeInfo.id != 1) {
      this.info.storeId = this.$store.state.storeInfo.id;
    }
  },
};
</script>

<style lang="less" scoped>
.tips {
  span {
    display: block;
    color: #999;
    line-height: 19px;
  }
}
</style>
